import { ArrowDown } from 'lucide-react'
import { haptics } from '@/utils/haptics'

interface ScrollToBottomProps {
  show: boolean
  unreadCount?: number
  onClick: () => void
}

export function ScrollToBottom({ show, unreadCount, onClick }: ScrollToBottomProps) {
  if (!show) return null

  const handleClick = () => {
    haptics.impact('light')
    onClick()
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-24 right-4 z-30 bg-white hover:bg-gray-50 active:bg-gray-100 text-gray-700 rounded-full shadow-lg border border-gray-200 p-3 transition-all animate-slide-up touch-target"
      aria-label="Ir al final"
    >
      <div className="relative">
        <ArrowDown className="w-5 h-5" />
        {unreadCount && unreadCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </div>
    </button>
  )
}
